import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';

export const GroupChatContainer = styled.div`
  ${({ theme }) => css`
    /* position: absolute;
    z-index: 99;
    top: 0;
    left: 0; */
    /* width: 100%;
    height: 100%; */
    /* padding: 8px;
    background: ${theme.colors.blackAlpha30}; */
  `}
`;

export const Background = styled.div`
  ${({ theme }) => css`
    position: absolute;
    z-index: 98;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px;
    background: ${theme.colors.blackAlpha30};
  `}
`;

export const InfoWrapper = styled(FlexStack)`
  overflow-y: auto;
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;
    flex-direction: column;
    width: 281px;
    height: 100%;
    padding: 8px;
    border-left: 1px solid ${theme.stroke.stroke_1};
    background: ${theme.backgroundColor.bg_dark_4_alpha};
    backdrop-filter: blur(50px);
    gap: 16px;
  `}
`;

export const ChatName = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.title.sub20_medium};
  `}
`;

export const ContentWrapper = styled(FlexStack)`
  padding: 0 8px;
`;

export const ContentTitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 8px;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    backdrop-filter: blur(50px);
    color: ${theme.content.content_light_2};
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);

    ${theme.fontStyle.text.body14_medium};
  `}
`;

export const ContentDetail = styled.p`
  ${({ theme }) => css`
    padding: 0 8px;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

export const CharacterTitle = styled.div`
  ${({ theme }) => css`
    padding: 8px;
    color: ${theme.content.content_light_5};
    ${theme.fontStyle.text.body14_medium};
  `}
`;

export const Character = styled(ContentDetail)`
  padding: 11px 8px;
`;

export const Members = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  }
`;

export const BlockButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 40px;
  height: 40px;
  cursor: pointer;
`;
